import React, { useState, ChangeEvent, FormEvent } from "react";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface FormFields {
  name: string;
  email: string;
  phone: string;
  date: string;
  guest: string;
  meal: string;
  message?: string;
}

const RSVPFrom2: React.FC = () => {
  const [forms, setForms] = useState<FormFields>({
    name: "",
    email: "",
    phone: "",
    date: "",
    guest: "",
    meal: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const [startDate, setStartDate] = useState<Date | null>(new Date());

  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();
      setForms({
        name: "",
        email: "",
        phone: "",
        date: "",
        guest: "",
        meal: "",
        message: "",
      });
    } else {
      validator.showMessages();
    }
  };

  return (
    <form
      onSubmit={submitHandler}
      className="contact-validation-active"
      method="post"
    >
      <div className="form-field">
        <input
          value={forms.name}
          type="text"
          name="name"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="Your Name"
        />
        {validator.message("name", forms.name, "required|alpha_space")}
      </div>

      <div className="form-field">
        <input
          value={forms.email}
          type="email"
          name="email"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="Your Email"
        />
        {validator.message("email", forms.email, "required|email")}
      </div>

      <div className="form-field">
        <input
          value={forms.phone}
          type="tel"
          name="phone"
          onBlur={changeHandler}
          onChange={changeHandler}
          className="form-control"
          placeholder="Your Phone"
        />
        {validator.message("phone", forms.phone, "required|numeric")}
      </div>

      <div className="form-field date">
        <DatePicker
          selected={startDate}
          onChange={(date: Date | null) => setStartDate(date)}
          className="form-control"
        />
      </div>

      <div className="form-field">
        <select
          onBlur={changeHandler}
          onChange={changeHandler}
          value={forms.guest}
          className="form-control"
          name="guest"
        >
          <option>Number Of Guests</option>
          <option>01</option>
          <option>02</option>
          <option>03</option>
          <option>04</option>
          <option>05</option>
          <option>06</option>
        </select>
        {validator.message("guest", forms.guest, "required")}
      </div>

      <div className="form-field">
        <select
          onBlur={changeHandler}
          onChange={changeHandler}
          value={forms.meal}
          className="form-control"
          name="meal"
        >
          <option>Meal Preferences</option>
          <option>Chicken Soup</option>
          <option>Mutton Kabab</option>
          <option>Chicken BBQ</option>
          <option>Mix Salad</option>
          <option>Beef Ribs</option>
        </select>
        {validator.message("meal", forms.meal, "required")}
      </div>

      <div className="form-field">
        <textarea
          onBlur={changeHandler}
          onChange={changeHandler}
          value={forms.message}
          className="form-control"
          name="message"
          placeholder="Message"
        />
        {validator.message("message", forms.message, "required")}
      </div>

      <div className="submit-area">
        <button type="submit" className="theme-btn">
          Send An Inquiry
        </button>
      </div>
    </form>
  );
};

export default RSVPFrom2;
